import { onlyDigits } from './string';
import { DateTime } from 'luxon';

export const validateBirthDate = (date: string) => {
  const birthDateOnlyDigits = onlyDigits(date);
  const rightDigitsAmount = birthDateOnlyDigits.length === 8;
  const formattedDate = DateTime.fromFormat(date, 'dd/MM/yyyy');
  const isValidDate =
    formattedDate.isValid &&
    formattedDate.year > 1899 &&
    DateTime.fromFormat(date, 'dd/MM/yyyy').toJSDate() < new Date();

  return rightDigitsAmount && isValidDate;
};

export const checkContainWordsRepeat = (text: string) => {
  const regexp = /(.)\1{2,}/gm;
  const textContaintWords = regexp.test(text);
  return textContaintWords;
};

export const checkContainWordsRepeatWithMinLength = (text: string, minLength: number) => {
  return !checkContainWordsRepeat(text) && text.length > minLength;
};

const checkForOnlyRepeatedChars = (text: string): boolean => {
  const regexp = /(.)\1{2,}/gm;
  const result = text.match(regexp);
  return !!result && result?.length > 0 && result[0].length === text.length;
};

const checkRomanNumbers = (text: string): boolean =>
  /^M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/.test(text) || checkExceptionalCases(text);

const checkContainOnlyDecimalNumber = (text: string): boolean => /^[0-9]*$/.test(text);

const checkExceptionalCases = (text: string): boolean =>
  ['LLL'].some((exceptionalCase) => text.includes(exceptionalCase));

export function checkAddress(text: string): boolean {
  const splittedAddress = text.trim().split(/[ ,]+/);

  if (splittedAddress.length === 1) {
    return !checkContainOnlyDecimalNumber(splittedAddress[0]) && !checkForOnlyRepeatedChars(splittedAddress[0]);
  }

  for (const word of splittedAddress) {
    const isOnlyRepeatedLettersThatAreNotRomanValuesOrDecimal = [
      checkForOnlyRepeatedChars(word),
      !checkContainOnlyDecimalNumber(word),
      !checkRomanNumbers(word),
      !checkExceptionalCases(word),
    ].every((val) => !!val);

    if (isOnlyRepeatedLettersThatAreNotRomanValuesOrDecimal) return false;
  }

  return true;
}
